import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// const vuetify = new Vuetify({

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#30B672',
        accent: '#30B672',
        anchor: '#8c9eff',
        background: '#ffffff'
      },
    },
  },
})